import { render, staticRenderFns } from "./index_user.vue?vue&type=template&id=08e09f84&scoped=true&"
import script from "./index_user.vue?vue&type=script&lang=js&"
export * from "./index_user.vue?vue&type=script&lang=js&"
import style0 from "./index_user.vue?vue&type=style&index=0&id=08e09f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e09f84",
  null
  
)

export default component.exports